import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esLogin from './locales/es/login.json';
import enLogin from './locales/en/login.json';
import headerEs from './locales/es/header.json';
import headerEn from './locales/en/header.json';
import starterEs from './locales/es/starter.json';
import starterEn from './locales/en/starter.json';
import simuladorEs from './locales/es/simulador.json';
import simuladorEn from './locales/en/simulador.json';
import productoEs from './locales/es/producto.json';
import productoEn from './locales/en/producto.json';
import activationEs from './locales/es/activation.json'
import activationEn from './locales/en/activation.json'


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            es: {
                login: esLogin,
                header: headerEs,
                starter: starterEs,
                simulador: simuladorEs,
                producto: productoEs,
                activation: activationEs

            },
            en: {
                login: enLogin,
                header: headerEn,
                starter: starterEn,
                simulador: simuladorEn,
                producto: productoEn,
                activation: activationEn
            },
        },
        fallbackLng: 'es',
        supportedLngs: ['es', 'en'],
        ns: ['login, header', 'starter', 'simulador', 'producto','activation'],
        defaultNS: 'login',

        interpolation: {
            escapeValue: false,
        },

        detection: {
            // Orden en que se detecta el idioma
            order: ['localStorage'],
            caches: ['localStorage'] // guarda la preferencia del usuario
        },

        react: {
            useSuspense: false, // evita problemas si no usas <Suspense>
        },
    });

export default i18n;
